import { useMutation, useQueryClient } from 'react-query';

import api from '@shared/api';

async function createPanelLibraryRevisionTemplate({
  code,
  templateId
}: {
  code: string;
  templateId: string;
}): Promise<void> {
  await api.post<{ code: string }>(
    `code-panels/mpm/templates/${templateId}/revisions`,
    { code }
  );
}

export function usePanelLibraryCreateTemplateRevisionMutation() {
  const queryClient = useQueryClient();

  return useMutation(
    ({ code, templateId }: { code: string; templateId: string }) => {
      return createPanelLibraryRevisionTemplate({
        code,
        templateId
      });
    },
    {
      onSuccess: async (_, { templateId }) => {
        await queryClient.invalidateQueries(
          ['panel-library-template-revisions', { templateId }],
          { refetchInactive: true }
        );

        await queryClient.refetchQueries(
          ['panel-library-template-code', { templateId }],
          { active: true, inactive: true }
        );

        await queryClient.invalidateQueries(
          ['panel-library-template-code', { templateId }],
          { refetchInactive: true }
        );
      }
    }
  );
}
